import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  backgroundColor: theme.palette.background.accent,
  borderLeft: '4px solid',
  borderColor: theme.palette.warning.main,
  padding: '12px 16px',
  gap: 8
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  userSelect: 'none'
});

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '0.875rem',
  flexGrow: 1
}));

export const ListContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  marginTop: 4,
  maxHeight: 320,
  overflowY: 'auto'
});

export const ExpandButton = styled(IconButton)({
  padding: 4,
  transition: 'transform 0.2s'
});

export const LocationRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  paddingLeft: 12,
  borderLeft: '2px solid',
  borderColor: theme.palette.divider
}));

export const LocationName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: theme.palette.text.primary
}));

export const LocationMessage = styled(Typography)(({ theme }) => ({
  fontSize: '0.8125rem',
  color: theme.palette.text.secondary
}));

export const CloseButton = styled(IconButton)({
  padding: 4
});

export const StyledCloseIcon = styled(CloseIcon)({
  fontSize: 18
});
